import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import CardContainer from '../../../components/card/card-container.jsx';
import LabelNumber from '../../../components/label/label-number.jsx';
import Api from '../../../api/global.service';
import { useAuth } from '../../../components/content/auth.jsx';
import env from '../../../environment.js';
import NoPagination from '../../../components/pagination/noPagination.jsx';
import LinkDownload from '../../../components/link/link-download.jsx';
import CheckboxList from '../../../components/forms/checkbox-list.jsx';
import './entregas-x-lote.css';
import LotesEntregasExport from './components/lotes-entregas-export.js';
import { useCoopConfig } from '../../../components/content/coop-config.jsx';
import { Colors } from '../../../constants';
import SearchColumn from '../../../components/search/search-column.jsx';
import ListToolbar, { BtnNuevo, BtnEliminar } from '../../../nuup/componentes/Toolbar/ListToolbar.jsx';
import transformWord from '../../../utils/transformWord.js';
import getBackgroundColor from '../../../utils/getBackgroundColor.js';
import getColor from '../../../utils/getColor.js';
import getRiesgoEudrLabel from '../../../nuup/utils/getRiesgoEudrLabel.js';
import LabelEudrProducer from '../../../components/label/label-eudr-prod.jsx';
import IDs_WHISP from '../../../constants/IdsWhisp.js';
import LinkDownloadExcel from '../../../components/link/link-download-excel.jsx';
import insertIf from '../../../utils/insertIf.js';
import LoteInfoCard from './components/LoteInfoCard.jsx';
import BackButton from '../../../components/link/back-button.jsx';

import ModalAsignarEntregas from './modals/modal-asignar-entregas.jsx';
import LoteDividirEntregaModal from './components/LoteDividirEntregaModal.jsx';

const EntregasXLoteList = () => {
  const auth = useAuth();
  const { state } = useLocation();
  const [currentLote, setCurrentLote] = useState(null);
  const [currentLoteWithEudr, setCurrentLoteWithDataEudr] = useState(null);

  const coopConfig = useCoopConfig();
  const [data, setData] = useState([]);
  const [entregasLote, setEntregasLote] = useState([]);

  const [blocking, setBlocking] = useState(true);

  const [idsSeleccionados, setIdsSeleccionados] = useState([]);
  const [estados, setEstados] = useState([]);
  const [producto, setProducto] = useState('café');


  // entregas
  const [selectedEntregas, setSelectedEntregas] = useState([]);
  
  const dialogAsignarEntregas = useRef(null);
  const dialogLoteDividirEntrega = useRef(null);


const currentLoteId = state?.id_lote || null;

  useEffect(() => {
    if (coopConfig?.config?.cooperativa?.producto?.nombre) {
      setProducto(coopConfig.config.cooperativa.producto.nombre);
    }
  }, [coopConfig.config]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'ENTREGA',
        columns: [
          {
            Header: (
              <input
                type="checkbox"
                name="entregasAll"
                onChange={e => handleCheckAll(e)}
                style={{
                  width: 20,
                  height: 20,
                  accentColor: Colors.primary_600,
                  display: data.length > 0 ? 'block' : 'none',
                }}
                checked={idsSeleccionados.length > 0 && idsSeleccionados.length === entregasLote.length}
                ref={el => el && (el.indeterminate = idsSeleccionados.length > 0 && entregasLote.length > idsSeleccionados.length)}
              />
            ),
            id: 'acopio_uuid',
            //accessor: 'acopio_uuid',
            sortable: false,
            width: 50,
            Cell: ({ row }) => {
              return (
                <>
                  <div className="form-check">
                    <CheckboxList
                      name="entregas"
                      value={row.original.acopio_uuid}
                      handleCheck={handleCheck}
                      checked={idsSeleccionados.includes(row.original.acopio_uuid) === true}
                    />
                  </div>
                </>
              );
            },
          },
          {
            Header: 'FECHA ENTREGA',
            accessor: 'fecha_acopio',
            sortable: true,
            minWidth: 80,
            Cell: ({ value }) => {
              return <p className="text-left">{value != null ? value.substr(0, 10) : ''}</p>;
            },
          },
          {
            Header: 'FOLIO ENTREGA',
            accessor: 'folio_acopio',
            sortable: true,
            minWidth: 50,
          },
          // {
          //   Header: 'ESTATUS',
          //   accessor: 'estatus_entrega',
          //   sortable: true,
          //   minWidth: 80,
          //   show: !btnLotes,
          //   Cell: ({ value, row }) => {
          //     return <LabelEstatus color={row.original.estatus_color_entrega} label={row.original.estatus_entrega} />;
          //   },
          // },
          {
            Header: `PESO ASIGNADO (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_asignado_lote',
            sortable: true,
            minWidth: 50,
            show: !coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PESO ASIGNADO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'peso_asignado_lote_extra',
            sortable: true,
            minWidth: 50,
            show: coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: 'RECIBOS',
            accessor: 'recibo_pdf',
            sortable: true,
            Cell: ({ value, row }) => {
              let v = value;
              return (
                <LinkDownload
                  url={`recibos/entregas/descargar/${row.original.acopio_uuid}`}
                  label="Descargar"
                  icon={env.images.icon.pdf}></LinkDownload>
              );
            },
          },
        ],
      },
      {
        Header: 'INFORMACIÓN DE PRODUCTOR',
        columns: [
          {
            Header: 'CLAVE',
            accessor: 'productor_clave_tx',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return (
                <p className="text-right" style={{ margin: 0 }}>
                  {value}
                </p>
              );
            },
          },
          {
            Header: 'CÓDIGO',
            accessor: 'productor_codigo_tx',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig.config?.usa_codigo_tx,
          },
          {
            Header: 'NOMBRE PRODUCTOR',
            accessor: 'productor_nombre',
            sortable: true,
            minWidth: 50,
            Cell: ({ value, row }) => {
              if (row.original.productor_uuid != null) {
                return (
                  <Link
                    to={{
                      pathname: `/admin/cuentas/perfil/${row.original.productor_uuid}`,
                    }}
                    className="m-r-2"
                    style={{ color: '#789D16' }}>
                    <span>{value}</span>
                  </Link>
                );
              } else {
                return value;
              }
            },
          },
          {
            Header: 'LOCALIDAD',
            accessor: 'localidad',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'REGIÓN',
            accessor: 'region',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'CENTRO DE ACOPIO',
            accessor: 'centro_acopio',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'RIESGO EUDR',
            accessor: 'riesgo_eudr',
            sortable: true,
            minWidth: 80,
            show: !!+coopConfig.config?.usa_eudr,
            Cell: ({ value }) => <LabelEudrProducer riesgo={getRiesgoEudrLabel(value)} />,
          },
        ],
      },
      {
        Header: 'INFORMACIÓN DE ENTREGA',
        columns: [
          {
            Header: 'Nº RECIPIENTES',
            accessor: 'no_bultos',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value}></LabelNumber>;
            },
          },
          {
            Header: `PESO BRUTO (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_bruto',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PESO TARA (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_tara',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PESO DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_descuento',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarDescuento() && !coopConfig.mostrarDescuentosPorcentaje(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `DESCUENTO${coopConfig.mostrarDescuentoHumedad() ? ' CALIDAD' : ''} (%)`,
            accessor: 'peso_descuento_perc',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarDescuento() && coopConfig.mostrarDescuentosPorcentaje(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'} />;
            },
          },
          {
            Header: `PESO DESCUENTO HUMEDAD (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_descuento_humedad',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarDescuentoHumedad() && !coopConfig.mostrarDescuentosPorcentaje(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `DESCUENTO HUMEDAD (%)`,
            accessor: 'peso_descuento_humedad_perc',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarDescuentoHumedad() && coopConfig.mostrarDescuentosPorcentaje(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'} />;
            },
          },
          {
            Header: `PESO NETO (${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'peso_neto',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PESO NETO (${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'peso_neto_extra',
            sortable: true,
            minWidth: 50,
            show: coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
        ],
      },
      {
        Header: 'TIPO DE ENTREGA',
        columns: [
          {
            Header: 'TIPO DE ' + transformWord(producto, ['uppercase']),
            accessor: 'tipo_cafe',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'PROCESO',
            accessor: 'proceso',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'CATEGORÍA ORGÁNICA',
            accessor: 'tipos_entregas',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarTipo(),
          },
        ],
      },
      {
        Header: 'RESULTADOS DE MUESTREO',
        columns: [
          {
            Header: 'MADURACIÓN',
            accessor: 'tipo_maduracion',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_tipo_maduracion,
          },
          {
            Header: 'RENDIMIENTO',
            accessor: 'rendimiento',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_rendimiento,
          },
          {
            Header: 'HUMEDAD',
            accessor: 'humedad',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_mancha,
          },
          {
            Header: 'DEFECTO',
            accessor: 'mancha',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2} suffix={'%'}></LabelNumber>;
            },
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_humedad,
          },
          {
            Header: 'COLOR',
            accessor: 'color',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_color,
          },
          {
            Header: 'COLOR',
            accessor: 'color_de_cafe',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_color_de_cafe,
          },
          {
            Header: 'AROMA',
            accessor: 'aroma',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_aroma,
          },
          {
            Header: 'OBSERVACIONES',
            accessor: 'observaciones',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_observaciones,
          },
          {
            Header: 'OBSERVACIONES',
            accessor: 'muestreo_observaciones',
            sortable: true,
            minWidth: 50,
            show: !!+coopConfig?.config?.config_muestreo?.mostrar_observaciones,
          },
          {
            Header: 'TIPO DE ' + transformWord(producto, ['uppercase']) + ' ENTREGADO',
            accessor: 'tipos_cafe',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarTipo(),
          },
          {
            Header: 'ESTATUS COSTALERA',
            accessor: 'nombre_cat_costaleras_estatus',
            sortable: true,
            minWidth: 50,
            show: coopConfig.mostrarCostalera(),
            Cell: ({ value }) => {
              if (value != null) {
                return (
                  <p className="text-left" style={{ margin: 0 }}>
                    {value}
                  </p>
                );
              } else {
                return (
                  <p className="text-left" style={{ margin: 0 }}>
                    {'-'}
                  </p>
                );
              }
            },
          },
        ],
      },
      {
        Header: 'INFORMACIÓN DE PAGO',
        columns: [
          {
            Header: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.acopioUnits()?.abreviacion})`,
            accessor: 'precio_por_kg',
            sortable: true,
            minWidth: 50,
            show: !coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PRECIO A PRODUCTOR (${coopConfig.currency()?.symbol}/${coopConfig.acopioUnitsExtra()?.abreviacion})`,
            accessor: 'precio_por_kg_extra',
            sortable: true,
            minWidth: 50,
            show: coopConfig.hasAcopioUnitsExtra(),
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2} />;
            },
          },
          {
            Header: `IMPORTE TOTAL (${coopConfig.currency()?.symbol})`,
            accessor: 'importe_total',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: 'DESCUENTOS DEUDAS',
            accessor: 'total_anticipos_recuperados',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `PAGADO A PRODUCTOR (${coopConfig.currency()?.symbol})`,
            accessor: 'pagado_a_productor',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: `SALDO DE LA ENTREGA (${coopConfig.currency()?.symbol})`,
            accessor: 'total_saldo',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} currencyLabel={coopConfig.currency()?.symbol} digits={2}></LabelNumber>;
            },
          },
          {
            Header: 'MÉTODO DE PAGO',
            accessor: 'metodo_pago',
            sortable: true,
            minWidth: 50,
          },
        ],
      },
      ...insertIf(!!+coopConfig.config?.usa_calidad, {
        Header: 'CALIDAD',
        columns: [
          { Header: 'ID MUESTRA', accessor: 'id_muestra', sortable: true, minWidth: 50 },
          { Header: 'TIPO DE MUESTRA', accessor: 'nombre_tipo_muestra', sortable: true, minWidth: 80 },
          {
            Header: 'RENDIMIENTO BRUTO (%)',
            accessor: 'rendimiento_bruto',
            sortable: true,
            minWidth: 60,
            Cell: ({ value }) => <LabelNumber value={value} digits={2} suffix={'%'} />,
          },
          {
            Header: 'RENDIMIENTO EXPORTABLE (%)',
            accessor: 'rendimiento_exportable_por',
            sortable: true,
            minWidth: 60,
            Cell: ({ value }) => <LabelNumber value={value} digits={2} suffix={'%'} />,
          },
          {
            Header: 'RENDIMIENTO REAL (%)',
            accessor: 'rendimiento_real',
            sortable: true,
            minWidth: 60,
            Cell: ({ value }) => <LabelNumber value={value} digits={2} suffix={'%'} />,
          },
          {
            Header: 'PUNTAJE EN TAZA',
            accessor: 'puntaje_manual',
            sortable: true,
            minWidth: 60,
            Cell: ({ value }) => <LabelNumber value={value} digits={2} />,
          },
        ],
      }),
    ],
    [idsSeleccionados, data]
  );

  useEffect(() => {
    const init = async () => {
      await getEstados();
      await getLoteInfo();
    }
    init();
  }, []);

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      { value: 1, target: 'fecha_acopio', label: 'FECHA ENTREGA' },
      { value: 2, target: 'estatus', label: 'ESTATUS' },
      { value: 3, target: 'folio_entrega', label: 'FOLIO ENTREGA' },
      { value: 4, target: 'fecha_entrega', label: 'FECHA ENTREGA' },

      { value: 5, target: 'productor_clave_tx', label: 'CLAVE' },
      { value: 6, target: 'productor_codigo_tx', label: 'CÓDIGO' },
      { value: 7, target: 'folio_acopio', label: 'FOLIO RECIBIDO' },
      { value: 8, target: 'productor_nombre', label: 'NOMBRE PRODUCTOR' },
      { value: 9, target: 'localidad', label: 'LOCALIDAD' },
      { value: 10, target: 'region', label: 'REGIÓN' },
      { value: 11, target: 'centro_acopio', label: 'CENTRO DE ACOPIO' },
      { value: 12, target: 'cuenta_categoria', label: 'CATEGORÍA' },

      { value: 13, target: 'no_bultos', label: 'Nº RECIPIENTES' },
      {
        value: 14,
        target: 'peso_bruto',
        label: `PESO BRUTO (${coopConfig.acopioUnits()?.abreviacion})`,
      },
      {
        value: 15,
        target: 'peso_tara',
        label: `PESO TARA (${coopConfig.acopioUnits()?.abreviacion})`,
      },
      {
        value: 16,
        target: 'peso_neto',
        label: `PESO NETO (${coopConfig.acopioUnits()?.abreviacion})`,
      },
      { value: 17, target: 'precio_por_kg', label: 'PRECIO A PRODUCTOR' },
      {
        value: 18,
        target: 'importe_total',
        label: `IMPORTE TOTAL (${coopConfig.currency()?.symbol})`,
      },
      {
        value: 19,
        target: 'total_anticipos_recuperados',
        label: 'DESCUENTOS DEUDAS',
      },
      {
        value: 20,
        target: 'pagado_a_productor',
        label: `PAGADO A PRODUCTOR (${coopConfig.currency()?.symbol})`,
      },
      {
        value: 21,
        target: 'total_saldo',
        label: `SALDO DE LA ENTREGA (${coopConfig.currency()?.symbol})`,
      },
    ],
    []
  );

  // Solo cuando existan entregasData de nuestro lote en pantalla, calculamos
  useEffect(() => {
    // Verificamos si ya hay entregas y si el lote NO tiene aún calculado el riesgo
    if (entregasLote.length > 0 && currentLote && typeof currentLote.riesgo_eudr === 'undefined') {
      
      const maxRisk = entregasLote.reduce((max, entrega) => {
        // En tu negocio, valor menor = riesgo más alto. (e.g. 1 es Riesgo Alto, 2 Medio...)
        if (entrega.riesgo_eudr && !isNaN(Number(entrega.riesgo_eudr)) && Number(entrega.riesgo_eudr) < Number(max)) {
          return Number(entrega.riesgo_eudr);
        }
        return max;
      }, IDs_WHISP.SIN_ASIGNAR);
      // Si obtuvimos un valor válido diferente a SIN_ASIGNAR, enriquecemos el State.
      if (maxRisk !== IDs_WHISP.SIN_ASIGNAR) {
        setCurrentLoteWithDataEudr({
          ...currentLote, // Mantenemos toda la información del detalle intacta
          riesgo_eudr: maxRisk // Inyectamos exclusivamente la nueva llave
        });
      }else{
        setCurrentLoteWithDataEudr({
          ...currentLote, // Mantenemos toda la información del detalle intacta
          riesgo_eudr: IDs_WHISP.SIN_ASIGNAR // Inyectamos exclusivamente la nueva llave
        });
      }
    } else {
      setCurrentLoteWithDataEudr(currentLote)
    }

  }, [entregasLote, currentLote]);
  
  const updateData = id_ciclo => {
    setBlocking(true);
    let filter = [
      // { column: 'id_ciclo', operator: '=', value: id_ciclo },
      { column: 'id_lote', operator: '=', value: currentLoteId }
    ];
    // if (idLote > 0) {
    //   filter.push({ column: 'id_lote', operator: '=', value: idLote });
    // }
    Api.Acopio.search('entregas_por_lote', { filter: filter })
      .then(async response => {
        let _data = response.data;
        setEntregasLote(_data);
        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log('error', e);
        setBlocking(false);
      });
  };

  const setDataFilter = data => {
    setData(data);
  };

    
    // ? get lotes by id 
    const getLoteInfo = () => {
    setBlocking(true);

    Api.Acopio.get('lotes_info/' + currentLoteId)
      .then(response => {
        setBlocking(false);
        // setShow(true);
        if (typeof response.data[0] !== 'undefined') {
          // setDataLotes(response.data); //Tabla lotes
          setCurrentLote(response.data[0]);
          updateData(Number(response.data[0].id_ciclo));
        } else {
          let err = response.data.data;
          // setErrors(err);
        }
      })
      .catch(e => {
        // setShow(false);
        setBlocking(false);
      });
  };
  

  const handleCheckAll = event => {
    if (event.target.checked === true) {
      setCheckData(data);
    } else {
      setIdsSeleccionados([]);
    }
  };

  const handleCheck = event => {
    let idsSel = idsSeleccionados;
    if (event.target.checked === true) {
      setIdsSeleccionados([...idsSel, event.target.value]);
    } else {
      idsSel = idsSel.filter(item => item !== event.target.value);
      setIdsSeleccionados(idsSel);
    }
  };

  const exportarXlsx = () => {
    LotesEntregasExport(data, currentLote?.nombre, coopConfig.mostrarCostalera(), coopConfig);
  };

  const setCheckData = () => {
    if (data.length > 0) {
      let uuids = [];
      let idSel = idsSeleccionados;
      if (idSel.length === 0) {
        uuids = data.map(d => {
          return d.acopio_uuid;
        });
      } else {
        let uuidsData = data.map(d => {
          return d.acopio_uuid;
        });
        uuids = idSel.concat(uuidsData.filter(item => idSel.indexOf(item) < 0));
      }
      setIdsSeleccionados(uuids);
    }
  };

  useEffect(() => {
    setData(entregasLote);
  }, [entregasLote]);

  const getEstados = () => {
    Api.getAll('acopios/catalogos/recoleccion_acopios_estatus')
      .then(response => {
        let estados = response.data;
        setEstados(
          estados.map(function (estado) {
            return {
              label: estado.nombre,
              value: estado.id,
              color: estado.color,
            };
          })
        );
      })
      .catch(e => {
        // eslint-disable-next-line no-console
      });
  };

  const desAsignarEntregasALote = async (entregas) => {
    const { data } = await Api.Acopio.create('lotes_asignacion', {
        id_lote:currentLote?.id,
        entregas,
        tipo:'eliminar',
      });
    return data;
  };

  const handleClickEliminarEntrega = async () => {
    if (idsSeleccionados.length === 0) {
      // todo: validar si es necesario agergar reglas
      return;
    }

    try {
      setBlocking(true);
      await desAsignarEntregasALote(idsSeleccionados);
      updateData();
      getLoteInfo()
      setIdsSeleccionados([]);

    } catch (error) {
      console.error('Error asignando entregas al lote', error);
    } finally {
      setBlocking(false);
    }
};

  const handleClickAsignarEntrega = () => {
    dialogAsignarEntregas.current.show();
  };

  const asignarEntregasALote = async (id_lote, entregas) => {
    const { data } = await Api.Acopio.create('lotes_asignacion', {
        id_lote,
        entregas,
        tipo:'agregar',
      });
    return data;
  };

  const handleClickGuardarEntregas = async () => {
    if (!currentLote?.id || selectedEntregas.length === 0) {
      // todo: validar si es necesario agergar reglas
      return;
    }
    const entregasUuids = selectedEntregas.map((entrega) => entrega.acopio_uuid);
    try {
      setBlocking(true);
      await asignarEntregasALote(currentLote.id, entregasUuids);
      updateData();
      getLoteInfo()
      setSelectedEntregas([]);
    } catch (error) {
      console.error('Error asignando entregas al lote', error);
    } finally {
      dialogAsignarEntregas.current.close();
      setBlocking(false);
    }
};
  
  const handleClickDividirEntrega = () => {
    dialogLoteDividirEntrega.current.show();
  };

  const onSuccessDividirEntrega = async () => {
    updateData()
    getLoteInfo()
    await dialogAsignarEntregas.current.fetchEntregas()
    setSelectedEntregas([])
  }

  return (
    <div>
      <div className="row justify-content-between mb-2 align-items-center">
        <BackButton 
        goBackDefault="/admin/acopio/lotes"
        border="0px" 
        />
        <div className="col-2 offset-1 poquitoAbajo">
          {auth.hasPermission('ACOPIOS_ENTREGAS_X_PRODUCTOR_EXPORTAR') && (
            <div className="d-flex justify-content-end mr-3">
              <LinkDownloadExcel handleExport={exportarXlsx} />

              {/* TODO: Move to EntregasXLotesDetails*/}
            </div>
          )}
        </div>
      </div>
      {/* Current lote information */}
      <LoteInfoCard loteData={currentLoteWithEudr} estados={estados} blocking={blocking}/>
      
      {/* Tabla de Entregas */}
        <>
        <div className="row mt-4">
          <div className="col-lg-4">
            <p>
              <span className="entregas-titulo">ENTREGAS</span>
              <span className="entregas-subtitulo"> ASOCIADAS AL LOTE</span>
            </p>
          </div>
        </div>
        <CardContainer height={'100%'}>
          <ListToolbar left={<SearchColumn data={entregasLote} columns={searchColumns} setDataFilter={evt => setDataFilter(evt)} />}>
            <BtnNuevo disabled={idsSeleccionados.length !== 0} onClick={() => handleClickAsignarEntrega()}>
              Agregar entrega
            </BtnNuevo>
            <BtnEliminar disabled={idsSeleccionados.length === 0} onClick={() => handleClickEliminarEntrega()}>
              Eliminar del lote
            </BtnEliminar>
          </ListToolbar>

          <NoPagination
            blocking={blocking}
            selected="id"
            columns={columns}
            data={data}
            fnBackgroundColor={getBackgroundColor}
            fnColor={getColor}
          />

          <div className="row mt-3">
            <div className="col-md-12">
              <p>{idsSeleccionados.length + ' seleccionados de un total de ' + data.length + ' registros'}</p>
            </div>
          </div>
        </CardContainer>
        </>

      <ModalAsignarEntregas
        ref={dialogAsignarEntregas}
        title="Asignar entregas a lote"
        loteData={currentLoteWithEudr}
        handleClickDividirEntrega={handleClickDividirEntrega}
        handleGuardarEntregas={handleClickGuardarEntregas}
        selectedEntregas={selectedEntregas}
        setSelectedEntregas={setSelectedEntregas}       
        />

      <LoteDividirEntregaModal
        ref={dialogLoteDividirEntrega}
        coopConfig={coopConfig}
        lote={currentLoteWithEudr}
        entregas={selectedEntregas}
        onSuccess={onSuccessDividirEntrega}
      />
    </div>
  );
};

export default EntregasXLoteList;
